import { PubSub } from '@instinet-analytics/core-lib';

export interface BarMouseOverState {
    bar?: 'buy' | 'sell' | 'net';
    key?: string;
    groupName?: string;
    y?: number;
}

export class BarMouseOver extends PubSub<BarMouseOverState> {}
